import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { OverlayPanel } from "primereact/overlaypanel";
import { Dropdown } from "primereact/dropdown";
import styled from "styled-components";

export const PriceYearNote = styled.span`
  font-size: 0.8rem;
  font-weight: 400;
  margin-left: 0.5rem;
  color: var(--text-color-secondary);
`;

const PriceYearIcon = styled.i`
  font-size: 1rem;
  cursor: pointer;
  color: var(--sumi-blue);
  flex-shrink: 0;
`;

const PriceYearPanel = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-width: 180px;
  background-color: #fff;
  box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.35);
`;

const PriceYearPanelTitle = styled.span`
  font-weight: 500;
  font-size: 0.9rem;
`;

const PriceYearDropdown = styled(Dropdown)`
  width: 100%;
`;

const ResetPriceYearButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-color-primary);
  text-decoration: underline;
  padding: 0;
  font-size: 0.85rem;
  text-align: left;
`;

interface PriceYearSelectorProps {
  priceYearOverride: number | null;
  setPriceYearOverride: (year: number | null) => void;
  priceYearOptions: { label: string; value: number }[];
  defaultYear: number;
}

const PriceYearSelector: React.FC<PriceYearSelectorProps> = ({
  priceYearOverride,
  setPriceYearOverride,
  priceYearOptions,
  defaultYear,
}) => {
  const { t } = useTranslation();
  const panelRef = useRef<OverlayPanel>(null);

  return (
    <>
      <PriceYearIcon
        className="pi pi-sliders-h"
        onClick={(e) => panelRef.current?.toggle(e)}
        title={t("label-select-price-year")}
      />
      <OverlayPanel ref={panelRef}>
        <PriceYearPanel>
          <PriceYearPanelTitle>
            {t("label-select-price-year")}
          </PriceYearPanelTitle>
          <PriceYearDropdown
            value={priceYearOverride ?? defaultYear}
            options={priceYearOptions}
            onChange={(e) =>
              setPriceYearOverride(e.value === defaultYear ? null : e.value)
            }
          />
          {priceYearOverride && (
            <ResetPriceYearButton onClick={() => setPriceYearOverride(null)}>
              {t("cmd-reset-price-year")}
            </ResetPriceYearButton>
          )}
        </PriceYearPanel>
      </OverlayPanel>
    </>
  );
};

export default PriceYearSelector;
